// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import { useState, useEffect } from "react";
import StackTable from "./components/VipParkingTable";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CreateVipParking from "./components/CreateVipParking";
import { getSpaces } from "store/slice/space/spaceSlice";
import { isEmpty } from "lodash";

function VIP() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const placesData = useSelector((state) => state.places?.selectedPlace);
  const { spaces } = useSelector((state) => state.spaces);
  let placeId =
    placesData?._id || new URLSearchParams(location?.search).get("placeId");

  useEffect(() => {
    if (isEmpty(spaces)) {
      dispatch(getSpaces(placeId));
    }
  }, [placeId]);

  return (
    <MDBox>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={1}
                mt={-2}
                py={1}
                px={1}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
                className="d-flex align-items-center gap-2"
              >
                <MDTypography
                  variant="h6"
                  color="white"
                  className="flex-grow-1"
                >
                  Space Settings
                </MDTypography>

                <MDButton
                  variant="outlined"
                  size="small"
                  onClick={() => setDialogOpen(true)}
                >
                  Create
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <StackTable slackData={spaces} />
                <CreateVipParking
                  dialogOpen={dialogOpen}
                  onClose={() => setDialogOpen(false)}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default VIP;
